import _ from 'lodash'
import { buildUrl } from '@/util'
const PublicQa = {
  namespaced: true,
  /**
   * All key is mapped from ` deliver created api`
   * @see https://github.com/nutspie/doc/blob/master/nuts-ranch/deliver/create.md
   */
  state: {
    /**
     * @see https://github.com/nutspie/doc/blob/master/nuts-ranch/deliver/publish.md
     * @prop {array<publish>} publishes - The collection of publish
     * @prop {string} publishes.id - Public qa's id
     * @prop {string} publishes.investor - Target investor
     * @prop {string} publishes.sender - The deliver's owner
     * @prop {string} publishes.price - The deliver's price
     * @prop {string} publishes.name - Owner's name
     * @prop {string} publishes.mobile - Owner's phone
     * @prop {string} publishes.weixin - Owner's wechat
     * @prop {string} publishes.email - Owner's email
     * @prop {string} publishes.bpName - The name of owner's bp
     * @prop {string} publishes.bpLink - The link of owner's bp
     * @prop {string} publishes.memo -
     * @prop {string} publishes.state -
     * @prop {string} publishes.delete -
     * @prop {string} publishes.orderNo -
     * @prop {string} publishes.create -
     * @prop {string} publishes.modify -
     * @prop {string} publishes.paid -
     * @prop {string} publishes.finish -
     * @prop {string} publishes.coupon -
     * @prop {string} publishes.couponAmount -
     * @prop {array}  publishes.qas - The questions and answers list.
     * @see https://github.com/nutspie/doc/blob/master/nuts-ranch/deliver/qa/query.md
     * @prop {string} publishes.qas.deliver - The deleiver id
     * @prop {string} publishes.qas.sender - 发送方：0-创业者；1-投资人
     * @prop {string} publishes.qas.message - 内容
     * @prop {string} publishes.qas.free - 免费：0-否；1-是
     * @prop {string} publishes.qas.state - 状态：0-未读；1-已读；2-失效
     * @prop {string} publishes.qas.publish - 发表：0-否；1-是
     * @prop {string} publishes.qas.sendTime - 发送时间
     * @prop {string} publishes.qas.readTime - 阅读时间
     * @prop {string} publishes.qas.group - 问答组
     */
    publishes: []
  },
  getters: {
    qas: (state, getters, rootState, storeGetters) => {
      const { card } = storeGetters['api/dartcome/user']
      const { publishes } = state
      const result = []
      for (let index = 0; index < publishes.length; index++) {
        publishes[index].qas.reduceRight((accumulator, item, index) => {
          const { group, senderId, sender, sendTime, message, type } = item
          let qa = accumulator.find(list => list.group === group)
          // Create qa
          if (!qa) {
            qa = {
              type: 'qa',
              group,
              answers: []
            }
            accumulator.push(qa)
          }

          // 用 replace 解决 weixin 浏览器无法解析 xxxx-xx-xx 时间格式的问题 (only xxxx/xx/xx)
          const time = new Date(sendTime.replace(/-/g, '/'))
          // Format audio data
          let audio = null
          if (type === 1) {
            audio = JSON.parse(message)
            audio.path = buildUrl(storeGetters.rootDomain, 'ranch', audio.path)
          }

          if (sender === 0) {
            qa.question = {
              sendTime: `${time.getFullYear()}-${time.getMonth() + 1}-${time.getDate()}`,
              message,
              audio,
              src: buildUrl(storeGetters.rootDomain, 'nutsbp', `/user/${senderId}/avatar`)
            }
          } else {
            qa.answers.unshift({
              name: card.name,
              title: card.title,
              sendTime,
              message,
              audio,
              src: card.head_image_url || `https://az.cdn.nutsbp.com/007/image/nuts_dartcome/pc/pr/cut_page/pr_default_image_small.png`
            })
          }
          return accumulator
        }, result)
      }
      return result
    }
  },
  actions: {
    async load ({ dispatch, rootGetters, commit }, params) {
      const { uuid } = _.get(rootGetters, 'api/dartcome/user')
      let data = await dispatch('api/ranch/r', {
        url: '/deliver/publish',
        data: {
          investor: uuid
        }
      }, {root: true})

      if (data.length !== 0) commit('SET_PUBLISHES', data)
    }
  },
  mutations: {
    SET_PUBLISHES (state, data) {
      state.publishes = data
      return state
    }
  }
}

export default PublicQa



// WEBPACK FOOTER //
// ./src/store/api/ranch/PublicQa.js